import axios from 'axios';
import {API_ROOT} from '../../api-config';

export function getCategories(response) {
    axios.defaults.withCredentials = true;
    axios.get(`${API_ROOT}/categories/`, {withCredentials: true})
        .then(function (ajax_response) {
            response(ajax_response.data);
        })
        .catch(function (error) {
            response({});
        });
}